/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Absence_TemperatureInputs */



/**
* | output |
* | --- |
* | "Absence temperature" |
*
* @param {Absence_TemperatureInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const absence_temperature = /** @type {((inputs?: Absence_TemperatureInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Absence_TemperatureInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Absence temperature")
	return /** @type {LocalizedString} */ ("Température d'absence")
});